import { useContext } from 'react';

import { useInfiniteQuery } from '@tanstack/react-query';
import axios from 'axios';

import { ConfigContext } from '../../../../aurr/contexts/ConfigContext';
import LoginContext from '../../../../aurr/contexts/LoginContext';
import { REPLIES_QUERY_KEY } from '../../constants';
import { KhorosRepliesProps } from '../../interface/khoros.interface';

export const useKhorosReplies = ({
  commentId,
  baseURL,
  pageSize,
  enabled,
}: KhorosRepliesProps) => {
  const { KHOROS_API } = useContext(ConfigContext);
  const { access_token } = useContext(LoginContext);

  const axiosConfig = {
    baseURL: baseURL || KHOROS_API,
    headers: {
      ...(access_token && { authorization: `Bearer ${access_token}` }),
      'Cache-Control': 'no-cache, max-age=0',
    },
  };

  return useInfiniteQuery({
    queryKey: [REPLIES_QUERY_KEY, { commentId }],
    queryFn: async ({ pageParam = 0 }) => {
      const response = await axios.get(
        `/services/v2/community/khoros/replies?parent_id=${commentId}&sortdir=desc&limit=${pageSize}&offset=${
          pageParam * pageSize
        }`,
        axiosConfig
      );
      return response?.data || undefined;
    },
    enabled,
    initialPageParam: 0,
    getNextPageParam: (lastPage, allPages) => {
      if (lastPage?.has_next_page === true) {
        return allPages.length;
      }
      return undefined;
    },
  });
};
